import React from 'react';
import { View } from 'react-native';
import {
  NativeSafeAreaViewProps,
  SafeAreaView as NativeSafeAreaView,
  Edge,
} from 'react-native-safe-area-context';

export default function SafeAreaView({
  edges = [],
  children,
  ...props
}: NativeSafeAreaViewProps) {
  if ((edges as Edge[]).length === 0) {
    return <View {...props}>{children}</View>;
  }

  return (
    <NativeSafeAreaView edges={edges} {...props}>
      {children}
    </NativeSafeAreaView>
  );
}
